export default "__VITE_ASSET__BDZF7oCf__"